module.exports = __webpack_public_path__ + "media/images/icon-logo-apple@3x-310cc64bfce5cb6aae1c7ebdec95384b.png";